<script setup>
import { computed, ref } from 'vue';
import MacroItem from '../../../../app/javascript/dashboard/routes/dashboard/conversation/Macros/MacroItem.vue';
import { macroCategories, macroPanelKeys } from './categories';
import { filterMacros } from './filterMacros';
import { groupMacros } from './groupMacros';

const props = defineProps({
  macros: {
    type: Array,
    required: true,
  },
  conversationId: {
    type: [Number, String],
    required: true,
  },
});

const query = ref('');
const closedGroups = ref({});

const groupedMacros = computed(() =>
  groupMacros(filterMacros(props.macros, query.value), macroCategories)
);

const toggleGroup = key => {
  closedGroups.value[key] = !closedGroups.value[key];
};
</script>

<template>
  <div class="orbex-macros-panel">
    <div class="orbex-macro-search-wrap">
      <div class="relative">
        <span
          aria-hidden="true"
          class="i-lucide-search absolute right-3 top-1/2 size-4 -translate-y-1/2 text-n-slate-9"
        />
        <input
          v-model="query"
          type="search"
          class="orbex-macro-search !mb-0 !pr-9"
          :aria-label="$t(macroPanelKeys.searchPlaceholder)"
          :placeholder="$t(macroPanelKeys.searchPlaceholder)"
        />
      </div>
    </div>

    <div class="flex flex-col gap-2 p-2">
      <section
        v-for="group in groupedMacros"
        :key="group.key"
        class="orbex-macro-group"
      >
        <button
          type="button"
          class="orbex-macro-group-header"
          :aria-expanded="!closedGroups[group.key]"
          @click="toggleGroup(group.key)"
        >
          <span class="flex min-w-0 items-center gap-2">
            <span
              aria-hidden="true"
              class="orbex-macro-category-icon size-4 flex-shrink-0"
              :class="group.icon"
            />
            <span class="truncate font-semibold">{{ $t(group.titleKey) }}</span>
            <span class="orbex-macro-count">{{ group.macros.length }}</span>
          </span>
          <span
            aria-hidden="true"
            class="size-4 text-n-slate-9"
            :class="
              closedGroups[group.key]
                ? 'i-lucide-chevron-down'
                : 'i-lucide-chevron-up'
            "
          />
        </button>

        <div v-show="!closedGroups[group.key]" class="space-y-1 p-1.5">
          <div
            v-for="macro in group.macros"
            :key="macro.id"
            class="orbex-macro-item"
          >
            <span
              aria-hidden="true"
              class="orbex-macro-item-icon size-4 flex-shrink-0"
              :class="group.icon"
            />
            <MacroItem
              class="min-w-0 flex-1"
              :macro="macro"
              :conversation-id="conversationId"
            />
          </div>
        </div>
      </section>

      <p
        v-if="!groupedMacros.length"
        class="p-5 text-center text-sm text-n-slate-10"
      >
        {{ $t(macroPanelKeys.noResults) }}
      </p>
    </div>
  </div>
</template>
